/**
 * Проверяет, есть ли минимум 2 элемента в массиве с указанным значением по ключу.
 * @param {Array} arr - Массив объектов.
 * @param {*} id - Искомое значение.
 * @param {string} key - Ключ для сравнения.
 * @returns {boolean} true, если найдено >= 2 совпадений.
 */
function hasDuplicateById(arr, id, key) {
  return arr.reduce((acc, item) => acc + (item[key] === id), 0) >= 2;
}

export default hasDuplicateById;
